import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, Container, AppBar, Toolbar, Box, CssBaseline } from '@mui/material';
import { Routes, Route, useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import EventBoard from './components/EventBoard';
import Search from './components/Search';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import logikoricon from './img/icon.png';
import Success from './components/Success';
import Error from './components/Error';
import Playground from './components/Playground';

const theme = createTheme({
  palette: {
    background: {
      default: "#f7f8fc"
    },
    primary: {
      main: "#2551a8",
      dark: "#193875",
      light: "#5073b9"
    },
    secondary: {
      main: "#149ecc",
      dark: "#0e6e8e",
      light: "#43b1d6"
    }
  },

});

export default function App() {

  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>

      <CssBaseline />

      <AppBar position="sticky" sx={{ background: '#233043' }}>
        <Toolbar variant="dense" sx={{ position: 'relative', display: 'flex', width: '100%', justifyContent: 'center' }}>
          <img src={logikoricon} height="35px" style={{ position: 'absolute', left: 10 }} />
          <Box sx={{ typography: 'h6' }}>Logikor Driver App</Box>
        </Toolbar>
      </AppBar>


      <Routes>
        <Route path="/" element={<Search />} />
        <Route path="/load/:loadNumber" element={<EventBoard />} />
        <Route path="/success" element={<Success />} />
        <Route path="/error" element={<Error />} />
        <Route path="/pg" element={<Playground />} />
      </Routes>

      <Paper square sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, }} elevation={3}>
        <BottomNavigation sx={{ background: '#233043',  height: '40px' }} showLabels variant="dense" >
          <BottomNavigationAction sx={{ color: '#FFF' }} label="Search Load" icon={<SearchIcon />} onClick={() => navigate('/')} />
        </BottomNavigation>
      </Paper>

    </ThemeProvider>
  );
}


